import { useContext } from "react";
import { GlobalContext } from "../context/GlobalState";
import Transaction from "./Transaction";

export default function TransactionList() {
    const { transactions } = useContext(GlobalContext);

    return (
        <div className="transaction-list">
            <h3>Recent Transaction</h3>
            <ul>
                {transactions.map((transaction) => <Transaction key={transaction.id} transaction={transaction} />)}
            </ul>
        </div>
    )
}
